import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import {
  getKindLikeValueSafely,
  getNonEmptyString,
} from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { UrlEditor } from './url-edit';
import { UrlView } from './url-view';

export const URL_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'url',
  editable: true,
  View: UrlView,
  Editor: UrlEditor,
  decode: (raw) => ({ kind: 'url', value: getNonEmptyString(raw) }),
  encode: (value) => getKindLikeValueSafely(value, 'url'),
  isEmpty: (value) => !getKindLikeValueSafely(value, 'url'),
};
